<div class="error-container">
  <img class="image" src="src/assets/404.png">

  <h3 class="m-b-15 m-t-25" i18nKey="errors.no_project.no_access"></h3>
  <p class="m-b-0" i18nKey="errors.no_project.no_access_message_1"></p>
  <p i18nKey="errors.no_project.no_access_message_2"></p>
</div>